export const Types = {
  OPEN_ADD_CONVERSION_PIXEL_MODAL: "OPEN_ADD_CONVERSION_PIXEL_MODAL",
  ADD_CONVERSION_PIXEL: "ADD_CONVERSION_PIXEL",
  OPEN_ADD_CONVERSION_PIGGYBACK_PIXEL_MODAL: "OPEN_ADD_CONVERSION_PIGGYBACK_PIXEL_MODAL",
  ADD_CONVERSION_PIGGYBACK_PIXEL: "ADD_CONVERSION_PIGGYBACK_PIXEL",
  UPDATE_CONVERSION_PIGGYBACK_PIXEL: "UPDATE_CONVERSION_PIGGYBACK_PIXEL",
  GET_ALL_CONVERSION_PIXELS: "GET_ALL_CONVERSION_PIXELS",
  CLEAR_CONVERSION_PIXEL_STATES: "CLEAR_CONVERSION_PIXEL_STATES",
};
